class OnBoardingContentController {
    constructor(settings, analyticsService, onBoardingService) {
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.onBoardingService = onBoardingService;
    }

    $onInit() {
        this.dialogCtrl.show();
    }
}

const onBoardingContentComponentDefinition = {
    controller: ['Settings', 'AnalyticsService', 'OnBoardingService', OnBoardingContentController],
    require: { dialogCtrl: '^dialog' },
    template: require('./onboarding-dialog-content.component.html').trim(),
};

module.exports = {
    OnBoardingContentController,
    onBoardingContentComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/onboarding/onboarding-dialog-content.component.js